// Small helpers shared across the approval bar + details modal.
// Pool leads sometimes carry values directly, sometimes nested under `leadData`.
export const getLeadValue = (lead, key) => lead?.[key] ?? lead?.leadData?.[key] ?? null;

export const formatLongText = (text, maxLength = 25) => {
	if (!text && text !== 0) return 'N/A';
	const str = String(text);
	return str.length > maxLength ? `${str.substring(0, maxLength)}...` : str;
};

// Initials for avatar chips (e.g. "Ahmed Al Mansoori" -> "AM").
export const getInitials = (name) => {
	if (!name) return 'NL';
	const parts = String(name).trim().split(/\s+/);
	if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
	return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};
